<template>
  <div class="l-edit-dialog-box">
    <el-form
      :model="form_data"
      label-width="120px"
      ref="form"
      :rules="rules"
      label-position="left"
      v-loading="loading"
    >
      <!-- <el-form-item label="上级设备类型" prop="pid" v-if="pid">
        <el-select ref="pid" v-model="form_data.pid" placeholder="请选择上级设备">
          <el-option :value="form_data.pid" :label="curr_pid_name" style="height: auto;padding:0">
            <el-tree ref="tree" :data="tree_data" default-expand-all :expand-on-click-node="false" node-key="id" highlight-current :props="defaultProps" @node-click="handleOrgSelect" :current-node-key="form_data.pid"></el-tree>
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item :label="nameProps" prop="name">
        <el-input v-model="form_data.name" autocomplete="off" :placeholder="`请输入${nameProps}`"></el-input>
      </el-form-item>

      <el-form-item label="设备类型图标" prop="img_icon">
        <l-upload-img
          :action="upload_action"
          name="img"
          :on-success="handleUploadIconSuccess"
          :preview-url="preview_url"
        />
        <div class="upload_style" @click="addSystemIcon">
          <i class="upload_style_icon el-icon-plus">
            <p>从系统中选择</p>
          </i>
        </div>
        <span v-show="preview_url == '' && form_data.img_icon == ''" class="upload_style_span">从本地导入</span>
        <l-dialog title="系统图标库" :visible.sync="dialogTableVisible" width="500px">
          <div class="w_icon">
            <ul>
              <li v-for="(item, index) in iconform" :key="index" @click="selectIcon(index)">
                <img :src="item.img_url" width="auto" height="50px"/>
                <p>{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </l-dialog>
      </el-form-item>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "l-dev-type-edit",
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    pid: {
      type: [Number, String],
      default: 0
    },
    companyId: {
      type: [Number, String],
      default: ""
    },
    visible: {
      type: Boolean
    },
    nameProps: {
      type: String,
      default: "设备类型名称"
    }
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      iconform: [],
      upload_action: Vue.$_config.api.domain + "/v1/dev_type/img_icon",
      loading: false, //页面是否加载中

      show_org_id_select: false,

      tree_data: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      curr_pid_name: "",

      //表单数据
      form_data: {
        pid: "",
        name: "",
        img_icon: ""
      },
      preview_url: "",
      //表单验证规则
      rules: {
        pid: [
          { required: true, message: "请选择上级设备类型", trigger: "change" }
        ],
        name: [
          {
            required: true,
            message: "设备类型名称不能为空",
            trigger: "change"
          }
        ],
        img_icon: [
          { required: true, message: "设备图标不能为空", trigger: "change" }
        ]
      },
      //提交按钮是否显示加载中
      submitting: false
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },

  methods: {
    selectIcon(index) {
      console.log("当前", this.preview_url);
      console.log(this.iconform[index]);
      this.form_data.name = this.iconform[index].name;
      this.form_data.img_icon = this.iconform[index].img;
      this.preview_url = this.iconform[index].img_url;
      console.log("赋值后", this.preview_url);
      console.log(this.form_data.img_icon);
      this.dialogTableVisible = false;
    },
    addSystemIcon() {
      this.dialogTableVisible = true;
      this.$_invoke("commonDevIcon_getList")
        .then(ret => {
          this.iconform = ret.data;
          console.log("icon", this.iconform);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //获取数据
    getData() {
      this.loading = true;
      if (this.hasId) {
        this.$_invoke("devType_getEditData", { id: this.$props.id })
          .then(ret => {
            //this.tree_data = ret.tree_data;
            this.form_data = ret.data;
            this.preview_url = ret.data.preview_url;
            // this.$nextTick(() => {
            //   this.form_data.pid = this.$props.pid;
            //   this.curr_tree_name = ret.curr_info.name;
            //   this.$refs.tree.setCurrentKey(ret.curr_info.id);
            // });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$_invoke("devType_getAddData", { pid: this.$props.pid })
          .then(ret => {
            this.tree_data = ret.tree_data;
            this.form_data.pid = this.$props.pid;
            // if (this.$props.pid) {
            //   this.$nextTick(() => {
            //     this.curr_tree_name = ret.curr_info.name;
            //     this.$refs.tree.setCurrentKey(ret.curr_info.id);
            //   });
            // }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //选中上级设备类型的处理方法
    handleOrgSelect(data) {
      this.form_data.org_id = data.id;
      this.curr_org_name = data.name;
      this.$refs.org.blur();
    },

    //上传图标成功后的回调
    handleUploadIconSuccess(res) {
      this.form_data.img_icon = res.data.img_url;
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {
            //添加
            this.form_data.company_id = this.$props.companyId;
            this.$_invoke("devType_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.$_invoke("devType_update", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    }
  }
};
</script>
